export default "__VITE_ASSET__cf73ee28__"